<template>
  <v-app>
    <v-overlay v-if="$store.state.loading" z-index="99999">
      <v-progress-circular
        indeterminate
        color="#a9182a"
        size="42"
      ></v-progress-circular>
    </v-overlay>

    <Navmenu
      v-if="
        $route.path != '/home' && $route.path != '/login' && $route.path != '/'
      "
      @openmenu="$refs.sidebarmenu.toggleMenu = true"
    />
    <main role="main">
      <router-view @openmenu="$refs.sidebarmenu.toggleMenu = true" />
      <Sidebarmenu
        ref="sidebarmenu"
        v-if="$route.path != '/login' && $route.path != '/'"
      />
    </main>
  </v-app>
</template>

<script>
import Navmenu from '@/components/Navmenu.vue'
import Sidebarmenu from '@/components/Sidebarmenu.vue'
export default {
  name: 'App',
  components: {
    Navmenu,
    Sidebarmenu,
  },
  mounted() {
    console.log('0.3.6')
  },
}
</script>
